import request from 'crm/utils/request'
import api from 'crm/common/api/tags'

export async function personalTags() {
    return request(api.personalTags.url)
}

export async function corpTags() {
    return request(api.corpTags.url)
}

export async function tag(payload) {
    return request(api.tag.url, {
        method: api.tag.type,
        body: payload.body,
    })
}
